import profileDefault from "@/assets/profile-80.json";
import { deepCopy } from "@/utils";

const state = {
  fileName: "AM",
  data: deepCopy(profileDefault),
  default: deepCopy(profileDefault),
  noLED: false,
};

const actions = {
  setFileName({ commit }, fileName) {
    commit("SET_FILE_NAME", fileName);
  },
  setData({ commit }, data) {
    data.key_layer.layer_data.map(({ layer }) => {
      layer.map((item, index) => {
        layer[index] = item.toUpperCase();
      });
    });
    commit("SET_DATA", data);
  },
  changeNoLED({ commit }) {
    commit("CHANGE_NO_LED");
  },
};

const mutations = {
  SET_FILE_NAME: (state, fileName) => {
    state.fileName = fileName;
  },
  SET_DATA: (state, data) => {
    state.data = data;
  },
  CHANGE_NO_LED: (state) => {
    state.noLED = !state.noLED;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
